import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

interface UserListParams {
    page?: number;
    limit?: number;
    search?: string;
}

interface User {
    _id: string;
    full_name: string;
    email_address: string;
    phone_number: string;
    role: string;
    status: string;
    createdAt: string;
}

interface UserListResponse {
    data: User[];
    count: number;
}

const BASE_URL = `/users`;

const UserService = {
    getUsers: (params?: UserListParams): Promise<AxiosResponse<UserListResponse>> => {
        const queryParams = {
            page: Number(params?.page),
            limit: Number(params?.limit),
            search: params?.search
        };

        return instanceAxios.post(`${BASE_URL}/ListUser`, queryParams);
    },

    getUserById: (id: any): Promise<AxiosResponse> => {
        return instanceAxios.get(`${BASE_URL}/${id}`);
    },

    createUser: (userData: Partial<User>): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}`, userData);
    },

    updateUser: (id: string, userData: Partial<User>): Promise<AxiosResponse> => {
        return instanceAxios.put(`${BASE_URL}/${id}`, userData);
    },

    deleteUser: (id: string): Promise<AxiosResponse> => {
        return instanceAxios.delete(`${BASE_URL}/${id}`);
    },

    userStatistics: (): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/userStatistics`, {});
    }
};

export default UserService;